<div class="container-fluid mt-3">
  <div class="row">
    @if (environment.structural || (!environment.people && !environment.structural && !environment.traffic)) {
    <div class="col-sm-4 col-12 mt-2">
      <mat-card [routerLink]="'/infrastructure/structural-health'" class="shadow-card">
        <mat-card-header>
          <mat-card-title>
            <div class="d-flex align-item-center">
              <mat-icon>engineering</mat-icon>{{ 'TITLE.STRUCTURAL_HEALTH' | translate }}
            </div>
          </mat-card-title>
          <mat-card-subtitle>{{ 'TITLE.STRUCTURAL_HEALTH_OVERVIEW' | translate }}</mat-card-subtitle>
        </mat-card-header>
        <img src="../../../assets/img/structural.jpg" class="view-card-img">
        <mat-card-content class="mt-2">
          {{ 'STRUCTURAL_HEALTH_DESC' | translate }}
        </mat-card-content>
        <mat-card-actions class="d-flex justify-content-end">
          <a mat-raised-button [routerLink]="'/infrastructure/structural-health'">{{ 'BUTTONS.VIEW' | translate }}</a>
        </mat-card-actions>
      </mat-card>
    </div>
    }

    @if (environment.people || (!environment.people && !environment.structural && !environment.traffic)) {
    <div class="col-sm-4 col-12 mt-2">
      <mat-card [routerLink]="'/stations/people'" class="shadow-card">
        <mat-card-header>
          <mat-card-title class="text-center">
            <div class="d-flex align-item-center gap-3">
              <mat-icon>people</mat-icon>{{ 'TITLE.PEOPLE_MOVEMENT' | translate }}
            </div>
          </mat-card-title>
          <mat-card-subtitle>{{ 'TITLE.PEOPLE_MOVEMENT_OVERVIEW' | translate }}</mat-card-subtitle>
        </mat-card-header>
        <img src="../../../assets/img/people.jpg" class="view-card-img">
        <mat-card-content class="mt-2">
          {{ 'PEOPLE_MOVEMENT_DESC' | translate }}
        </mat-card-content>
        <mat-card-actions class="d-flex justify-content-end">
          <a mat-raised-button [routerLink]="'/stations/people'">{{ 'BUTTONS.VIEW' | translate }}</a>
        </mat-card-actions>
      </mat-card>
    </div>
    }

    @if (environment.traffic || (!environment.people && !environment.structural && !environment.traffic) ||
    (environment.traffic && environment.structural)) {
    <div class="col-sm-4 col-12 mt-2">
      <mat-card [routerLink]="'/infrastructure/traffic-monitoring'" class="shadow-card">
        <mat-card-header>
          <mat-card-title class="text-center">
            <div class="d-flex align-item-center gap-3">
              <mat-icon>traffic</mat-icon>{{ 'TITLE.TRAFFIC_MONITORING' | translate }}
            </div>
          </mat-card-title>
          <mat-card-subtitle>{{ 'TITLE.TRAFFIC_MONITORING_OVERVIEW' | translate }}</mat-card-subtitle>
        </mat-card-header>
        <img src="../../../assets/img/traffic.jpg" class="view-card-img">
        <mat-card-content class="d-flex mt-2">
          {{ 'TRAFFIC_MONITORING_DESC' | translate }}
        </mat-card-content>
        <mat-card-actions class="d-flex justify-content-end">
          <a mat-raised-button [routerLink]="'/infrastructure/traffic-monitoring'">{{ 'BUTTONS.VIEW' | translate }}</a>
        </mat-card-actions>
      </mat-card>
    </div>
    }
  </div>
</div>